//PCA Live Chat constants
export const DEFAULT_PCA_LIVE_CHAT_FLAG_VALUE = true;
export const SHOW_PCA_LIVE_CHAT_ICON = 'show-pca-live-chat-icon';

//Fraud and disputes constants
export const DEFAULT_FRAUD_AND_DISPUTES_FLAG_VALUE = true;
export const SHOW_FRAUD_DISPUTES = 'show-fraud-disputes';
